import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";

export const notificationsApi = createApi({
  reducerPath: "notificationsApi",
  baseQuery,
  tagTypes: ["CmsNotifications"],
  endpoints: (builder) => ({
    fetchNotifications: builder.query({
      query: ({ filter = "all", cursor } = {}) => ({
        url: "notifications",
        params: { filter, ...(cursor ? { cursor } : {}) },
      }),
      transformResponse: (res) =>
        res?.success
          ? res.data
          : { items: [], unreadCount: 0, hasMore: false, nextCursor: null },
      providesTags: [{ type: "CmsNotifications", id: "LIST" }],
    }),
    markNotificationRead: builder.mutation({
      query: ({ notificationId }) => ({
        url: `notifications/${notificationId}/read`,
        method: "PATCH",
      }),
      transformResponse: (res) => res?.data,
      async onQueryStarted({ notificationId }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          ["all", "unread"].forEach((cachedFilter) => {
            dispatch(
              notificationsApi.util.updateQueryData(
                "fetchNotifications",
                { filter: cachedFilter },
                (draft) => {
                  const item = draft?.items?.find((entry) => entry.id === notificationId);
                  if (item?.readAt) return;
                  draft.unreadCount = Math.max(0, Number(draft.unreadCount || 0) - 1);
                  if (cachedFilter === "unread") {
                    draft.items = draft.items.filter((entry) => entry.id !== notificationId);
                  } else if (item) {
                    item.readAt = data.readAt;
                  }
                },
              ),
            );
          });
        } catch {
          // Keep the authoritative cached state unchanged on failure.
        }
      },
    }),
    markAllNotificationsRead: builder.mutation({
      query: () => ({
        url: "notifications/read-all",
        method: "PATCH",
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: [{ type: "CmsNotifications", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchNotificationsQuery,
  useLazyFetchNotificationsQuery,
  useMarkNotificationReadMutation,
  useMarkAllNotificationsReadMutation,
} = notificationsApi;
